<template>
	<div class="page-main">

		<div class="app-appbar">
			<nav-bar title="请选择店铺" />

			<div class="page-form">
				<div class="left" @click="toCity">
					<span v-if="getCity && getCity.city">{{ getCity.city }}</span>
					<span v-else>全部</span>
					<span class="icon">
						<img src="~@/assets/ic_right_arrow_dark.png" />
					</span>
				</div>

				<div class="right">
					<form action="#" class="input" @submit.prevent="submit">
						<input type="search" v-model="query" placeholder="请输入搜索门店或地址" />
						<img class="icon" src="~@/assets/query.png" @click="submit" />
					</form>
				</div>
			</div>

			<div class="results-row">
				搜索结果（{{getList.length}}家门店）
			</div>
		</div>

		<ul class="page-store-list">
			<li class="store-item" :class="{'closing':item.pretime_str==='结束营业'}" v-for="item in getList" :key="item.id"
				@click="chooseShop(item)">
				<div class="name">{{ item.name }}</div>
				<p class="p" v-html="item.address1 || item.address"></p>
				<p class="p">营业时间: {{item.business_time_str}}</p>
				<p class="p">{{item.pretime_str}}</p>
			</li>
		</ul>

		<div v-if="isloading" class="isloading">
			<loading size="24px">加载中...</loading>
		</div>
		<div v-else>
			<no-list v-if="getList.length==0" text="没有找到相关门店"></no-list>
		</div>
	</div>
</template>

<script>
	import {
		NavBar,
		loading
	} from "vant";
	import {
		mapGetters
	} from "vuex";
	import {
		getShop,
		queryStore
	} from "@/api";
	import noList from "@/components/noList"

	export default {
		data() {
			return {
				isloading: true,
				query: "",
				shopList: [],
			};
		},
		methods: {
			submit() {
				this.shopList = [];
				this.isloading = true;
				
				if (this.query) {
					queryStore(this.query).then(d => {
						this.isloading = false;
						this.shopList = d['data'] || [];
					})
				} else {
					getShop().then((d) => {
						this.isloading = false;
						this.shopList = d.data || [];
					});
				}
			},
			toCity() {
				this.$router.replace({
					name: "city"
				});
			},
			chooseShop(d) {
				this.$store.commit("setStore", d);
				this.$store.commit("setCity", d);
				this.$router.replace({
					name: "home"
				});
			},
		},
		computed: {
			...mapGetters({
				getCity: "getCity",
			}),
			getList() {
				var list = this.shopList;
				// if (this.query) {
				//   list = [];

				//   for (var item of this.shopList) {
				//     var bool =
				//       item.name.indexOf(this.query) != -1 ||
				//       item.address.indexOf(this.query) != -1;
				//     if (bool) {
				//       var _item = Object.assign({}, item);
				//       _item.address1 = _item.address.replace(
				//         this.query,
				//         "<span>" + this.query + "</span>"
				//       );
				//       list.push(_item);
				//     }
				//   }
				// }
				return list;
			},
		},
		created() {
			this.submit()
		},
		components: {
			NavBar,
			loading,
			noList
		}
	};
</script>

<style lang="scss" scoped>
	.page-main {
		min-height: 100vh;
	}

	.page-form {
		height: 100px;
		display: flex;

		.left {
			width: 240px;
			display: flex;
			justify-content: center;
			align-items: center;

			.icon {
				width: 30px;
				height: 30px;
				margin-left: 6px;

				img {
					width: 100%;
					height: 100%;
					display: block;
				}
			}
		}

		.right {
			flex: 1;
			position: relative;

			&::after {
				content: "";
				position: absolute;
				left: 0;
				top: 20px;
				bottom: 20px;
				width: 1px;
				background: #ddd;
			}

			.input {
				padding: 20px 30px;
				position: relative;

				.icon {
					position: absolute;
					right: 50px;
					top: 30px;
					width: 35px;
					height: 35px;
					opacity: 0.5;
				}

				input {
					width: 100%;
					height: 60px;
					padding: 0 50px 0 30px;
					border: none;
					background: #f1f1f1;
					box-sizing: border-box;
					border-radius: 30px;
				}
			}
		}
	}

	.results-row {
		padding: 0 40px;
		background: #f8f8f8;
		color: #999;
		line-height: 80px;
		height: 80px;
		font-weight: bold;
	}

	.page-store-list {
		margin-top: 46PX;
		padding-top: 180px;

		.store-item {
			padding: 25px 40px 20px;
			position: relative;

			&.closing {
				opacity: 0.5;
			}

			&::after {
				content: "";
				height: 1px;
				position: absolute;
				bottom: 0;
				left: 40px;
				right: 40px;
				background: #ddd;
			}

			.name {
				margin-bottom: 6px;
				font-size: 26px;
				font-weight: bold;
			}

			.p {
				margin: 0;
				letter-spacing: 1px;

				::v-deep span {
					color: #999;
				}
			}
		}
	}

	.isloading {
		text-align: center;
		padding-top: 90px;
	}
</style>